
import React from "react";
import PageLayout from "@/components/layout/PageLayout";
import GettingStartedSection from "@/components/faq/GettingStartedSection";
import ProtocolsSection from "@/components/faq/ProtocolsSection";
import TargetGenerationSection from "@/components/faq/TargetGenerationSection";
import TokensSection from "@/components/faq/TokensSection";
import TechnicalSection from "@/components/faq/TechnicalSection";
import SupportSection from "@/components/faq/SupportSection";
import SEO from "@/components/SEO";

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "What is remote viewing?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Remote viewing is the practice of describing details about a distant or unseen target using extrasensory perception. RemoteViz provides randomized targets and AI feedback so you can practice and track accuracy.",
      },
    },
    {
      "@type": "Question",
      name: "How do I start a session?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Generate a new target from the chat, record your impressions, then reveal the target to receive AI feedback on your accuracy.",
      },
    },
    {
      "@type": "Question",
      name: "What target types are available?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Locations (Google Maps / Street View), images (Unsplash), and prediction events (binary markets that resolve within two weeks).",
      },
    },
    {
      "@type": "Question",
      name: "Is my data secure?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes. Sessions and impressions are stored securely with encrypted transmission and are never shared or used for purposes outside of providing feedback.",
      },
    },
  ],
};

const FAQs: React.FC = () => {
  return (
    <PageLayout title="FAQs">
      <SEO
        title="FAQs — RemoteViz.ai Remote Viewing Practice"
        description="Answers about remote viewing protocols, target types, tokens, privacy, and how to get the most out of RemoteViz."
        path="/faqs"
        jsonLd={faqJsonLd}
      />
      <div className="max-w-4xl mx-auto py-12 px-6">
        <h1 className="text-4xl mb-8">FAQs</h1>
        
        <div className="prose prose-gray max-w-none">
          <div className="space-y-8">
            <GettingStartedSection />
            <ProtocolsSection />
            <TargetGenerationSection />
            <TokensSection />
            <TechnicalSection />
            <SupportSection />
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default FAQs;
